import { c as _c } from "react/compiler-runtime";
import type { Entity, Investigation } from '@onefootprint/request-types/dashboard';
import { StatusBadge } from '@/components';
import FraudLabel from '@/components/fraud-label';
import IdDropdown from '@/components/id-dropdown';
import Labels from '@/components/labels';
import Tags from '@/components/tags';
import useInvestigationIdItems from '../../hooks/use-investigation-id-items';
type IdentityRowProps = {
  investigation: Investigation;
  /** Optional: investigations may have no entity (e.g. a Percy orchestrator parent). */
  entity?: Entity;
};

// The header's second row: investigation IDs, status, labels, fraud label, and tags.
// The originating agent is surfaced in the header's Agents menu, and custom-status
// selectors behind the Statuses popover — not inline here.
export const IdentityRow = t0 => {
  const $ = _c(16);
  const {
    investigation,
    entity
  } = t0;
  const idItems = useInvestigationIdItems(investigation, entity);
  let t1;
  if ($[0] !== idItems) {
    t1 = <IdDropdown items={idItems} />;
    $[0] = idItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entity) {
    t2 = entity && <><span aria-hidden="true">·</span><StatusBadge status={entity.status} requiresManualReview={false} /></>;
    $[2] = entity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== entity) {
    t3 = entity && <Labels entity={entity} />;
    $[4] = entity;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entity) {
    t4 = entity && <FraudLabel />;
    $[6] = entity;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== entity) {
    t5 = entity && <Tags />;
    $[8] = entity;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex flex-wrap items-center gap-x-2 gap-y-1 min-w-0 text-body-2 text-tertiary">{t1}{t2}{t3}{t4}{t5}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default IdentityRow;